'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moveto = require('moveto');

var _moveto2 = _interopRequireDefault(_moveto);

var _reactRouterDom = require('react-router-dom');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var aAllowedAttributes = ['charset', 'coords', 'download', 'href', 'hreflang', 'name', 'ping', 'referrerpolicy', 'rel', 'rev', 'shape', 'target', 'type', 'onClick', 'style'];

var scrollToLocation = function scrollToLocation(event, href, tolerance, history) {
  var hash = href.replace('#', '');
  event.preventDefault();
  if (hash !== '') {
    if (history.push) {
      history.push((0, _extends4.default)({}, history.location, { hash: hash }));
    } else {
      location.hash = hash;
    }
    var element = document.getElementById(hash.replace('#', ''));
    var moveTo = new _moveto2.default({
      tolerance: tolerance
    });

    moveTo.move(element);
  }
};

function SmoothLink(props) {
  var children = props.children,
      href = props.href,
      tolerance = props.tolerance,
      className = props.className,
      location = props.location,
      history = props.history;

  var aProps = (0, _keys2.default)(props).reduce(function (result, key) {
    if (aAllowedAttributes.includes(key)) {
      return (0, _extends4.default)({}, result, (0, _defineProperty3.default)({}, key, props[key]));
    }

    return result;
  }, {});

  var active = location.hash.substr(1) === href.replace('#', '');

  return _react2.default.createElement(
    'a',
    (0, _assign2.default)({}, aProps, { className: (className || '') + ' ' + (active ? 'active' : ''), href: '#' + href.replace('#', ''), onClick: function onClick(event) {
        return scrollToLocation(event, href, tolerance, history);
      } }),
    children
  );
}

SmoothLink.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node,
  href: _propTypes2.default.string.isRequired,
  tolerance: _propTypes2.default.number,
  location: _propTypes2.default.object.isRequired,
  history: _propTypes2.default.object.isRequired
};
SmoothLink.defaultProps = {
  className: undefined,
  children: null,
  tolerance: 40
};

exports.default = (0, _reactRouterDom.withRouter)(SmoothLink);


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-utilities/build/SmoothLink.js
// module id = 1063
// module chunks = 0